import {Dispatch} from 'redux';
import {connect} from 'react-redux';
import ValidationIdWaitingResponseView from '../../../components/views/mx/creditoReal/ValidationIdWaitingResponseView';
import {State} from '../../../types/mx/reducers';

const mapStateToProps = (state: State) => {
    return {};
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
    return {};
};

const ValidationIdWaitingResponseContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ValidationIdWaitingResponseView);

export default ValidationIdWaitingResponseContainer;
